import React, { Component } from 'react'
import {Redirect} from "react-router-dom";
import UserRepo from '../../repository/user';
import {subscribe} from 'alfa';

class LoginConfirm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    }
  }

  componentDidMount() {
    this.getUser();
  }

  getUser() {
    let params = new URLSearchParams(window.location.search);
    params.set('seed', localStorage.getItem('authseed'))
    UserRepo.authConfirm(params).then(
      result => {
        const data = result.data;
        localStorage.setItem("user", JSON.stringify(data.user));
        localStorage.setItem("token", btoa(JSON.stringify(data.token)));
        localStorage.removeItem("authseed");
        this.props.set('user', data.user);
        this.setState({
          loading: false,
        })
      }
    )
  }

  render () {
    if (this.state.loading) {
      return "loading..."
    }

    return <Redirect to='/' />
  }
}

export default subscribe(LoginConfirm, ['set', 'user'], ['user']);